module.exports = __webpack_public_path__ + "static/media/client_m_0.ef95918d.png";